import { render, staticRenderFns } from "./experiment_badge.vue?vue&type=template&id=071fb1a4"
import script from "./experiment_badge.vue?vue&type=script&lang=js"
export * from "./experiment_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports